export function getChartSummary(communicationId) {
  return `{
  communicationSurveyResultByQuestion(communicationId: ${communicationId}) {
    question {
        id
        description
        type
        numberOfAnswer
    }
    chartData {
        label
        value
        responsible {
            id
            fullName
        },
        descritiveAnswer
        trueQuantity
        falseQuantity
    }
  }
}`;
}

export function getChartIndividual(communicationId) {
  return `{
  communicationSurveyResultInDetail(communicationId: ${communicationId}) {
    responsible {
      id
      fullName
    }
    questions {
      id
      description
      type
      answers {
        id
        description
        correct
        trueOrFalse
        selected
        responsibleAnswer
      }
    }
  }
}
`;
}

export function getChartQuestion(communicationId) {
  return `{
  chartQuestion(communicationId: ${communicationId}) {
    id
    description
    type
    chartData {
      value
      label
      description
    }
    chartAnswer {
      questionDescription
      chartData {
        value
        label
        description
      }
      descriptionAnswers {
        id
        description
        communicationId
        answer
      }
    }
  }
}`;
}
